import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Title = styled(Typography)(({ theme }) => ({
  margin: "10px 0 2px",
  color: theme.palette.neutral.light,
}));

export const Options = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral.light,
}));
